import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import ServiceDropboxSelector from '@/components/Ui/ServiceDropboxSelector'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'

export default {
  name: 'ContentsScreenSaver',
  components: {
    FileSelectorButton,
    ServiceDropboxSelector
  },
  data () {
    return {
      inited: false,

      // input
      input: {
        screenSaverUseFlg: 0,
        startDelayTime: 0,
        dataSource: '',
        dropBoxFile: {
          serviceDropboxUuid: null,
          fileType: ''
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceContentsSetting.categoryName,

      // form
      serviceId: state => state.serviceContentsSettingForm.serviceId,
      serviceContentsId: state => state.serviceContentsSettingForm.targetId,
      values: state => state.serviceContentsSettingForm.values,
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
      isRegister: 'serviceContentsSettingForm/isRegister',
      isModify: 'serviceContentsSettingForm/isModify',
    }),

    // list
    screenSaverUseList () {
      return Constants.ServiceContents.ScreenSaverUse.sort(Utility.sortByKey('index', true))
    },
    screenSaverDataList () {
      return Constants.ServiceContents.ScreenSaverData
    },

    // show
    showDetailItems () {
      return this.input.screenSaverUseFlg === 1
    },
    showDropboxAttributes () {
      return this.showDetailItems &&
        this.input.dataSource === 1
    },

    // validate
    formIsValid () {
      const v1 = this.validate('screenSaverUseFlg')
      if (!v1) return false

      let v2 = false
      if (this.input.screenSaverUseFlg === 1) {
        v2 = this.validate('startDelayTime') &&
          this.validate('dataSource')
        // dropbox設定
        if (v2 && this.input.dataSource === 1) {
          v2 = this.validate('dropBoxFile.serviceDropboxUuid') &&
            this.validate('dropBoxFile.fileType')
        }
      } else {
        v2 = true
      }
      if (!v2) return false

      return true
    },

    // jsonb
    getJsonb () {
      let jsonb = {
        screenSaverUseFlg: this.input.screenSaverUseFlg
      }

      // スクリーンセーバー利用
      if (jsonb.screenSaverUseFlg === 1) {
        jsonb.startDelayTime = this.input.startDelayTime
        jsonb.dataSource = this.input.dataSource
        
        // Dropbox設定
        if (jsonb.dataSource === 1) {
          this.$set(jsonb, 'dropBoxFile', this.input.dropBoxFile)
        }
      }
      
      return jsonb
    },
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate({
          key: 'contentsScreenSaver',
          value: this.formIsValid
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({

    }),
    ...mapMutations({
      setValidate: 'serviceContentsSettingForm/setValidate'
    }),

    init () {
      if (this.values.contentsScreenSaver) {
        let data = $.extend(true, this.input, this.values.contentsScreenSaver)
        this.$set(this, 'input', data)
      }

      // 必須項目なし、もしくはラジオボタンのみの場合
      this.setValidate({
        key: 'contentsScreenSaver',
        value: true
      })

      this.inited = true
    },

    /**
     * ファイル
     */
    getInputNode (name) {
      let nodes = name.split('.')
      let origin = this.input
      let key
      nodes.forEach((item, index) => {
        if (index < nodes.length - 1) {
          origin = origin[item]
        } else {
          key = item
        }
      })
      return {
        parent: origin,
        key: key
      }
    },
    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, Jsonb.formatFile(props.data))
      console.log('changeFileFromSelector', data.parent[data.key])
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, null)
      console.log('deleteFileFromSelector', null)
    },

    /**
     * Dropbox設定の変更
     */
    changeDropboxValue (props) {
      console.log('changeDropboxValue', props)
      this.$set(this.input, 'dropBoxFile', props.value)
    },

    validate (key) {
      let data = this.getInputNode(key)
      let value = data.parent[data.key]
      switch (key) {
        case 'screenSaverUseFlg':
          return Validator.validRadio(value)
        case 'startDelayTime':
          return Validator.validText(value)
        case 'dataSource':
        case 'dropBoxFile.fileType':
          return Validator.validSelect(value)
        case 'dropBoxFile.serviceDropboxUuid':
          return Validator.validText(value)
      }
    },
  }
}
